<template>
  <div class="spinner" id="spinner" style="display:none;">
    <div class="spinner__svg">

      <svg class="spinner__smiley" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.42 76.42">
        <circle class="spinner__loader__path__bg" cx="38.21" cy="38.21" r="35.21" fill="white" stroke-width="4" />
        <circle cx="27.21" cy="29.34" r="3.78" class="primary" />
        <circle cx="49.23" cy="29.34" r="3.78" class="primary" />
        <path class="primary" d="M38.38,60.69A22,22,0,0,1,18.54,48,3.02158,3.02158,0,0,1,24,45.41,15.82,15.82,0,0,0,52.5,46a3,3,0,1,1,5.40752,2.59976q-.03664.0762-.07752.15024a21.91,21.91,0,0,1-19,12Z" />
      </svg>
      <svg class="spinner__loader" viewBox="25 25 50 50">
        <circle class="spinner__loader__path" cx="50" cy="50" r="20" fill="none" stroke-width="3" />
      </svg>
    </div>
  </div>
</template>
<script>
  export default {

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
